export default function getSubStrings(str, maxLength) {
    if (!str.length) {
        return [];
    }
    let result = [];
    let i = Math.min(str.length, maxLength);
    do {
        result.push(str.substr(0, i));
    } while (--i);
    if (str.length > 1) {
        result = result.concat(getSubStrings(str.substr(1), maxLength));
    }
    return result;
}
//# sourceMappingURL=get_sub_strings.js.map